/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { MARITAL_STATUS, CELLPHONE_DETAILS, REGULAR_DRIVER, CELLPHONE_CASE } from '../../../routes/routes';
import './Bling.css';
import { ProgressBar, Button, Dropdown, Image, Form } from 'react-bootstrap';
import { postToController } from '../../../actions/apiActions';
import { navigateTo } from '../../../actions/navigationActions';
import { addCarToQuote, postRegularDriverFlow, setRegularDriver, setSelectedDriver, setRegularPhoneNumber } from '../../../actions/salesActions';
import { validateCellphoneNumber } from '../../../constants/validation';

class CellphoneRegistrationNumber extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            phoneNumber: '',
            phoneNumberRegex: true,
            submitted: false,
            loggedIn: this.props.auth.uid ? true : false,
            phoneNumberActiveOnPoilicy: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
        this.checkCellphoneNumberActive = this.checkCellphoneNumberActive.bind(this);
    }

    async componentDidMount() {
    }

    async handleRegularDriverSelection(e: any) {
        /* eslint eqeqeq: "off" */
        let coverItem = this.state.regularDriverList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({ selectedRegularDriver: coverItem[0] });
        this.setState({ nextDisabled: coverItem[0] === undefined });
    }

    async handleSelectedRegularDriverDropdownToggle(e: any) {
        await this.setState({
            selectedRegularDriverDropdown: !this.state.selectedRegularDriverDropdown
        });
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        if (name === "phoneNumber") {
            var valid = validateCellphoneNumber.test(value)
            await this.setState({ phoneNumberRegex: valid });
            if (this.state.phoneNumberRegex) {
                await this.checkCellphoneNumberActive();
            }
        }
    }

    async checkSubmit() {
        const { phoneNumber, phoneNumberActiveOnPoilicy } = this.state;
        if (validateCellphoneNumber.test(phoneNumber) && !phoneNumberActiveOnPoilicy) {
            await this.setState({ nextDisabled: false });
        } else {
            await this.setState({ nextDisabled: true });
        }
    }

    handleClick() {
        this.props.dispatchSetRegularPhonenumber(this.state.phoneNumber)
        this.props.dispatchRedirectTo(CELLPHONE_CASE)
    }

    async handleBack(e: any) {
        this.props.dispatchRedirectTo(CELLPHONE_DETAILS)
    }

    handleRedirect(nextPage: string) {
        this.props.dispatchRedirectTo(nextPage);
    }

    async checkCellphoneNumberActive() {
        await postToController(this.props.dispatch, 'IsCellPhoneNumberOnActiveRiskItem', JSON.stringify({ Parameter: this.state.phoneNumber})).then(async (response) => {            
            var quoteNumbers = this.props.sales.addedBlingNumbers;

            if (quoteNumbers && quoteNumbers.filter(x => x == this.state.phoneNumber).length > 0) {
                response = true;
            }
            await this.setState({ phoneNumberActiveOnPoilicy: response, nextDisabled: response })
            return true;
        })
    }

    public render() {
        const { phoneNumber, submitted, phoneNumberRegex, phoneNumberActiveOnPoilicy } = this.state;
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-05 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container ssp-add-portable-possessions-replacement-value">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={45} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        <div className="ssp-cellphone-reg-number-main-contentholder mt-21px mobile-mt-17px mb-30px text-center ssp-addreplacement-value-p-holder">
                                            <div className="mb-0px font-size-16px font-weight-500 ssp-addreplacement-value-intro-header">
                                                Please give us the number of the phone that’s being insured
                                            </div>
                                        </div>
                                        <div className="form-row noma ssp-addreplacement-value-tile-holder-row">
                                            <div className="col-12 nopa">
                                                <div className={'form-group mb-0px' + (submitted && !phoneNumber ? ' has-error' : '')}>
                                                    <Form.Label className={'left-align temp-text-box-label pl-1 mb-6px' + (this.state.phoneNumber !== "" ? "" : " no-opacity d-none")}>Phone no.</Form.Label>
                                                    <Form.Control type="text" placeholder="Phone no." name="phoneNumber" value={this.state.phoneNumber} onChange={this.handleChange} className={phoneNumberRegex && phoneNumberActiveOnPoilicy ? "invalid-cellphone" : "" } />
                                                    <div className="help-block">
                                                        {!phoneNumberRegex ? <div>This field must be 10 characters</div> : null}
                                                    </div>
                                                    {submitted && !phoneNumber &&
                                                        <div className="help-block">Contact number is required</div>
                                                    }
                                                    {phoneNumberRegex && phoneNumberActiveOnPoilicy &&
                                                        <div className="error-block ml-20px">Oops! Our records show that this number’s already being used by another phone.
                                                            Remember, 1 phone = 1 cellphone number.</div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row noma justify-content-center mt-40px">
                                            <div className="col-12 col-lg-4 nopa cellphone-reg-button-holder">
                                                <button type="submit" className="btn btn-block btn-solid-red button-width cursor-pointer" id="" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        cart: state.cart,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchRedirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetRegularPhonenumber: (regularPhoneNumber: any) => dispatch(setRegularPhoneNumber(regularPhoneNumber)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CellphoneRegistrationNumber);